import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import api, { BASE_URL } from "../../Utils/api";
import { Senha } from "../Generals/Inputs";


function ModalAlterarSenhaObrigatoria({ show, userId, token, onSucesso }) {
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [erro, setErro] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const handleSalvar = async () => {
    setErro(null);
    if (!novaSenha.trim()) {
      setErro("Informe a nova senha.");
      return;
    }
    if (novaSenha.length < 6 || novaSenha.length > 128) {
      setErro("A senha deve possuir entre 6 e 128 caracteres.");
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setErro("As senhas não conferem.");
      return;
    }
    setSalvando(true);
    try {
      await api.put(
        `${BASE_URL}/api/usuarios/AlterarSenhaObrigatoria/${userId}`,
        { senha: novaSenha },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSucesso();
    } catch (err) {
      setErro(err?.response?.data?.message || "Erro ao alterar senha.");
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      animation={false}
      dialogClassName="modal-dialog-top"
    >
      <Modal.Header style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          Definir Nova Senha — Primeiro Acesso
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        <p className="text-muted mb-3" style={{ fontSize: "0.9rem" }}>
          Sua senha é temporária. Defina uma nova senha para continuar.
        </p>
        {erro && <div className="alert alert-danger py-2">{erro}</div>}
        <div className="mt-2">
          <Senha
            id="obr-novaSenha"
            label="Nova Senha"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            placeholder="••••••••"
          />
        </div>
        <div className="mt-3">
          <Senha
            id="obr-confirmarSenha"
            label="Confirmar Nova Senha"
            value={confirmarSenha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            placeholder="••••••••"
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-direita">
          <Button variant="primary" onClick={handleSalvar} disabled={salvando}>
            {salvando ? "Salvando..." : "Confirmar"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAlterarSenhaObrigatoria;
